const style = {
  organizationPersonasTable__cell_action: {
    paddingLeft: '10px',
  },
  tableBody: {},
};

export default style;
